module.exports = __webpack_public_path__ + "img/facebook@2x.3df79378.png";